var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import CtaButton from '../../../components/CtaButton';
import { localizeUrl } from '../../../core/helpers/url-helper';
import { createOrder } from '../../Order/store/actions';
var mapStateToProps = function (state) { return ({
    order: state.order,
}); };
var mapDispatchToProps = {
    createOrder: createOrder,
};
var connector = connect(mapStateToProps, mapDispatchToProps);
var CheckoutForm = /** @class */ (function (_super) {
    __extends(CheckoutForm, _super);
    function CheckoutForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: false,
            checkboxError: false,
            isChecked: false,
        };
        return _this;
    }
    CheckoutForm.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "c-form-element" },
                React.createElement("label", { className: "c-toggle-checkbox" },
                    React.createElement("input", { type: "checkbox", value: "1", className: "c-form-element__input c-toggle-checkbox__input", onChange: function (event) { return _this.setState({
                            isChecked: event.target.checked,
                            checkboxError: false,
                        }); } }),
                    React.createElement("span", { className: "c-toggle-checkbox__span" },
                        React.createElement("i", { className: "icon-checkmark" }),
                        React.createElement(Trans, { i18nKey: "cart.checkout.checkbox.label" },
                            React.createElement("a", { href: localizeUrl(this.props.t('route.terms_and_conditions.slug')), target: "_blank" })))),
                this.state.checkboxError && (React.createElement("div", { className: "c-form-element__error" }, this.props.t('cart.checkout.checkbox.error')))),
            React.createElement("div", { className: "h-padding-top--40 h-padding-top--md-20" },
                React.createElement(CtaButton, { icon: "arrow-right", modifier: ['yellow', 'full', 'icon-right'], label: "cart.button.checkout", clickHandler: function () { return _this.handleSubmit(); }, isDisabled: this.state.isLoading }))));
    };
    CheckoutForm.prototype.handleSubmit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var couponCode, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.state.isChecked) {
                            this.setState({ checkboxError: true });
                            return [2 /*return*/];
                        }
                        this.setState({ isLoading: true });
                        couponCode = localStorage && localStorage.getItem('coupon') ? localStorage.getItem('coupon') : null;
                        return [4 /*yield*/, this.props.createOrder(global.App.locale.locale, couponCode)];
                    case 1:
                        response = _a.sent();
                        if (!response) {
                            alert('Something went wrong.');
                            return [2 /*return*/];
                        }
                        if (couponCode) {
                            localStorage.removeItem('coupon');
                        }
                        window.location.href = localizeUrl("/stripe-checkout/" + response.secret + "/redirect");
                        return [2 /*return*/];
                }
            });
        });
    };
    return CheckoutForm;
}(React.Component));
export default connector(withTranslation()(CheckoutForm));
